module.exports = new __parcel__URL__("nextjs.72f3cb54.svg").toString();